import React from 'react';
import PropTypes from 'prop-types';
import BlockchainUrlField from "./BlockchainUrlField";

const AddressField = (props) => {
  return <BlockchainUrlField
    mode='address'
    {...props}
  />;
};

AddressField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  currencySource: PropTypes.string,
};

AddressField.defaultProps = {
  record: {},
  source: 'address',
  currencySource: 'currency',
  label: 'Address',
  addLabel: true,
};

export default AddressField;
